module.exports = __webpack_public_path__ + "img/lira-logo.065e1e69.png";